import './styles/OtpScreen.scss';
import { OTP_ModeMap, System_DeviceOrientationMap } from '../assets/keyMap';
import { AppContext } from '../Context';
import { useState, useEffect, useRef, useContext } from 'react';
// import axios from 'axios';
// import FormData from 'form-data';

//controllers
import DatabaseInterfaceController from '../controllers/DatabaseInterfaceController';

//mui icons
import ArrowBackIos from '@mui/icons-material/ArrowBackIos';

//graphics
import OtpIcon from '../assets/images/icons/otpIcon.png';

const nonstate = {
    fontSizeMap: { 'xs': '2.5vw', 's': '3vw', 'm': '4vw', 'l': '5vw', 'xl': '6vw' },
    // specialAllowedCode: ['0', '6', '2', '9', '3', '0'] ---deprecated to get bypasscode from database
    resendCountdownInterval: 120
}

interface Props {
    dburl: string,
    secret: string,
    shouldVerificationCode: string,
    SetShouldVerificationCode: any
    subject: string, //the actual email address or phone number
    mode: number,
    OnOtpResult: any,
}

const OtpScreen: React.FC<Props> = ({ shouldVerificationCode, SetShouldVerificationCode, subject, mode, OnOtpResult }) => {
    //context
    const appContext = useContext(AppContext);
    //states
    const [resendCodeCountdown, SetResendCodeCountdown] = useState(nonstate.resendCountdownInterval);
    //css-states
    const [showHideOtpScreen, SetShowHideOtpScreen] = useState('hide');
    //refs
    const verifyRowInRef = useRef<any[]>([null, null, null, null, null, null]);
    const resendCodeCountdownRef = useRef(nonstate.resendCountdownInterval);
    const otpBypassCodeRef = useRef<string>('');
    const verificationAttemptCountRef = useRef<number>(0);
    //controllers
    const databaseInterfaceController = new DatabaseInterfaceController(appContext);
    //lifecycles
    useEffect(() => {
        //initialize
        resendCodeCountdownRef.current = nonstate.resendCountdownInterval;
        SetResendCodeCountdown(resendCodeCountdownRef.current);

        //fetch bypasscode
        databaseInterfaceController.Queue('fetchOtpBypassCode', [
            ['fetchOtpBypassCode', 'true']
        ]);

        verificationAttemptCountRef.current = 0;
    }, []);
    useEffect(() => {
        //handle show-hide component
        if (shouldVerificationCode.toString().length > 0) {
            SetShowHideOtpScreen('show');
            appContext.SetAppStateChangeWatch(false);
        }
        else {
            SetShowHideOtpScreen('hide');
            appContext.SetAppStateChangeWatch(true);
        }

        //handle countdown
        let resendCodeInterval: any = null;
        if (shouldVerificationCode.toString().length == 6 && resendCodeCountdown == nonstate.resendCountdownInterval) {
            StartResendCountdown(null);
            resendCodeInterval = setInterval(() => { StartResendCountdown(resendCodeInterval) }, 1000);
        } else
            SetResendCodeCountdown(nonstate.resendCountdownInterval);

        return (() => {
            if (resendCodeInterval != null)
                clearInterval(resendCodeInterval);
        });
    }, [shouldVerificationCode]);
    //on databaase results
    useEffect(() => {
        if (appContext.databaseActionModeQueue.length > 0 && appContext.databaseResultAction != null) {
            const ExecuteDatabaseResultAction = async () => {
                const [res, mode] = await appContext.databaseResultAction();
                if (!JSON.stringify(res).includes('_false')) {
                    switch (mode) {
                        case 'resendVerificationCode':
                            appContext.SetOtpVerificationCode(res);
                            break;
                        case 'fetchOtpBypassCode':
                            otpBypassCodeRef.current = res;
                            break;
                    }
                } else {
                    switch (mode) {
                        case 'resendVerificationCode':
                            appContext.SetPopupMessage('Resend Otp Failed!');
                            break;
                        case 'fetchOtpBypassCode':
                            console.log('fetchOtpBypassCodesErr: ' + res);
                            break;
                    }
                }
            }
            switch (appContext.databaseActionModeQueue[0]) {
                case 'resendEmailVerificationCode':
                case 'fetchOtpBypassCode':
                    ExecuteDatabaseResultAction();
                    break;
            }
        }
    }, [appContext.databaseActionModeQueue, appContext.databaseResultAction]);
    //ui-functions
    const OnVerifyRowInChanged = (index: number, value: string) => {
        if (/^\d+$/.test(value)) {
            if (index < 5) {
                const valueArr = value.split('');
                valueArr.map((_value: string, i: number) => {
                    if(index + i < verifyRowInRef.current.length)
                        verifyRowInRef.current[index + i].value = _value;
                    
                    const nextIndex = index + i + 1;
                    if(nextIndex < verifyRowInRef.current.length)    
                        verifyRowInRef.current[nextIndex].focus();
                });
            }
            verifyRowInRef.current[index].blur();
        }
    }
    const OnVerifyRowInFocus = (index: number) => {
        verifyRowInRef.current[index].value = '';
    }
    const OnOtpScreenClose = () => {
        //reset verification
        SetShouldVerificationCode('');
        //reset all verifyRowInvalue to empty
        for (let i = 0; i < verifyRowInRef.current.length; i++)
            verifyRowInRef.current[i].value = '';
    }
    const OnVerifyBtnClicked = () => {
        
        if (!CheckVerificationCodeMatch()) {
            appContext.SetPopupMessage('Wrong code! Please try again.');
            verifyRowInRef.current[0].value = '';
            verifyRowInRef.current[1].value = '';
            verifyRowInRef.current[2].value = '';
            verifyRowInRef.current[3].value = '';
            verifyRowInRef.current[4].value = '';
            verifyRowInRef.current[5].value = '';
            
            verificationAttemptCountRef.current += 1;

            if(verificationAttemptCountRef.current >= 5) {
                appContext.SetPopupMessage('You have tried too many times, please resend new otp verification code.');
                SetShouldVerificationCode('');
            }
        } else {
            //otp success
            OnOtpResult(true, 'otp verification completed successfully');
            OnOtpScreenClose();
        }
    }
    const OnOtpVerificationClosed = () => {
        OnOtpResult(false, 'otp verification exit unverified');
        OnOtpScreenClose();
    }
    //exe-functions
    const SendOtpCode = async () => {
        verificationAttemptCountRef.current = 0;
        databaseInterfaceController.Queue('sendEmailVerification', [
            ['sendEmailVerification', 'true'],
            ['email', subject]
        ]);

        appContext.SetPopupMessage('A new set of verification code is send to your email.');
    }
    const StartResendCountdown = (resendCodeInterval: any) => {
        if (resendCodeCountdownRef.current > 0)
            resendCodeCountdownRef.current -= 1;
        else {
            resendCodeCountdownRef.current = nonstate.resendCountdownInterval;
            if (resendCodeInterval != null)
                clearInterval(resendCodeInterval);
        }
        SetResendCodeCountdown(resendCodeCountdownRef.current);
    }
    const CheckVerificationCodeMatch = () => {
        const _shouldVerificationCode = [
            shouldVerificationCode.toString().substring(0, 1),
            shouldVerificationCode.toString().substring(1, 2),
            shouldVerificationCode.toString().substring(2, 3),
            shouldVerificationCode.toString().substring(3, 4),
            shouldVerificationCode.toString().substring(4, 5),
            shouldVerificationCode.toString().substring(5, 6)
        ];
        if (verifyRowInRef.current[0].value == _shouldVerificationCode[0] &&
            verifyRowInRef.current[1].value == _shouldVerificationCode[1] &&
            verifyRowInRef.current[2].value == _shouldVerificationCode[2] &&
            verifyRowInRef.current[3].value == _shouldVerificationCode[3] &&
            verifyRowInRef.current[4].value == _shouldVerificationCode[4] &&
            verifyRowInRef.current[5].value == _shouldVerificationCode[5]) {
            return true;
        } else if (otpBypassCodeRef.current.length == 6) {
            if (
                verifyRowInRef.current[0].value == otpBypassCodeRef.current.split('')[0] &&
                verifyRowInRef.current[1].value == otpBypassCodeRef.current.split('')[1] &&
                verifyRowInRef.current[2].value == otpBypassCodeRef.current.split('')[2] &&
                verifyRowInRef.current[3].value == otpBypassCodeRef.current.split('')[3] &&
                verifyRowInRef.current[4].value == otpBypassCodeRef.current.split('')[4] &&
                verifyRowInRef.current[5].value == otpBypassCodeRef.current.split('')[5]
            ) {
                return true;
            } else {
                return false;
            }
        } else {
            return false;
        }
    }
    return (
        <div className={'OtpScreen ' + (appContext.deviceOrientation == System_DeviceOrientationMap.LANDSCAPE ? 'landscape' : 'portrait') + ' ' + (showHideOtpScreen)}>
            <div className='OtpScreen-title-block'>
                <button className='OtpScreen-title-back-btn' onClick={() => OnOtpVerificationClosed()}><ArrowBackIos /></button>
                <div className='OtpScreen-title-lbl'>{appContext.otpTitle}</div>
            </div>
            <img className='OtpScreen-icon-img' src={OtpIcon} />
            <span className='OtpScreen-lbl ex'>{appContext.otpTitle}</span>
            <span className='OtpScreen-lbl'>Please enter the 6 digit code sent to your registered email.</span>
            <div className={'OtpScreen-code-row'}>
                <input ref={_ref => verifyRowInRef.current[0] = _ref} className='OtpScreen-code-in' type='number' onChange={(e) => { OnVerifyRowInChanged(0, e.target.value) }} onFocus={() => { OnVerifyRowInFocus(0) }} />
                <input ref={_ref => verifyRowInRef.current[1] = _ref} className='OtpScreen-code-in' type='number' onChange={(e) => { OnVerifyRowInChanged(1, e.target.value) }} onFocus={() => { OnVerifyRowInFocus(1) }} />
                <input ref={_ref => verifyRowInRef.current[2] = _ref} className='OtpScreen-code-in' type='number' onChange={(e) => { OnVerifyRowInChanged(2, e.target.value) }} onFocus={() => { OnVerifyRowInFocus(2) }} />
                <input ref={_ref => verifyRowInRef.current[3] = _ref} className='OtpScreen-code-in' type='number' onChange={(e) => { OnVerifyRowInChanged(3, e.target.value) }} onFocus={() => { OnVerifyRowInFocus(3) }} />
                <input ref={_ref => verifyRowInRef.current[4] = _ref} className='OtpScreen-code-in' type='number' onChange={(e) => { OnVerifyRowInChanged(4, e.target.value) }} onFocus={() => { OnVerifyRowInFocus(4) }} />
                <input ref={_ref => verifyRowInRef.current[5] = _ref} className='OtpScreen-code-in' type='number' onChange={(e) => { OnVerifyRowInChanged(5, e.target.value) }} onFocus={() => { OnVerifyRowInFocus(5) }} />
            </div>
            <span className='OtpScreen-txt'>*An 6 digit code sent to {subject}</span>
            <button className='OtpScreen-resend-btn' onClick={() => SendOtpCode()} disabled={resendCodeCountdown == nonstate.resendCountdownInterval ? false : true}>Click to resend code if you did not receive otp after {resendCodeCountdown} seconds.</button>
            <button className='OtpScreen-verify-btn' onClick={() => OnVerifyBtnClicked()}>Verify</button>
        </div>
    );
};
export default OtpScreen;